import { Action, ActionReducer, createReducer, on, ReducerTypes } from '@ngrx/store';
import { withDatagridReducer } from '../datagrid-slice.function';
import { withEntityReducer } from '../entity-slice.function';
import * as featureActions from './actions';
import { initialState, ITiersStoreState } from './state';

// declare our fully typed reducer
export function createTiersReducer<A extends Action = Action>(
	initialState,
	...ons: ReducerTypes<ITiersStoreState, any>[]
): ActionReducer<ITiersStoreState, A> {
	return createReducer(initialState, ...ons);
}

const featureReducer = createTiersReducer(
	initialState,

	...withEntityReducer<ITiersStoreState>('tiersForm', featureActions.TiersFormActions),
	...withDatagridReducer<ITiersStoreState>('tiersList', featureActions.TiersListActions),

	on(featureActions.SetDisableSubmitButton, (state, action) => ({
		...state,
		isSubmitButtonDisabled: action.param
	})),

	on(featureActions.OpenTiersForm, (state, action) => ({
		...state,
		tiersForm: {
			...state.tiersForm,
			isLoading: false
		}
	}))
);

export function tiersStoreReducer(state: ITiersStoreState, action: Action): ITiersStoreState {
	return featureReducer(state, action);
}
